import React, { useContext, useRef, FormEvent } from 'react'
import { BotStore } from './Store'
import { base, login } from './bot-loaders';
import { Form } from './form/address-form';
import { useErrorAlert } from './components/use-animation';
import { Alert } from './components/Alert';
import { logEvent } from './ga/ga-event-logger';

export function Login(){
    const ctx = useContext(BotStore);
    const ref = useRef<HTMLInputElement>();
    const passRef = useRef<HTMLInputElement>();
    const [error, setError, shakeClass] = useErrorAlert()

    async function doLogin(e:FormEvent){
        e.preventDefault();
        const email  = ref.current.value
        const password  = passRef.current.value

        if(!email) return setError("Informar Email");
        if(!password) return setError("Informar Senha");

        try {
            var session = await login(email, password)
            ctx.dispatch({type: "setNeedsLogin", payload: false});
            ctx.dispatch({type: "setSession", payload: session});
            logEvent({type: "account_event",  params: {account_action: "login", account_name: session.account.name}})
        }catch(e){
            if(e == 'lock')
                return setError("Serviço suspenso para esta conta.");
            console.log(e);
            setError("Falha ao logar")
        }
    }

    return <div className='container my-4 d-flex align-items-center justify-content-center' style={{height: "calc(100vh - 3rem)"}}>
        <div className='card shadow' style={{minWidth:"340px"}}>
            <div className='card-body'>
                <form onSubmit={doLogin}>
                <img className='d-block mx-auto resgata-logo' style={{cursor:'pointer'}} src={`${base}logo-resgata-facil.png`} width={67 * 3.76} height={67} /> 
                <h3 className='text-center mb-4 opacity-75'>Login</h3>
                <input ref={ref} className='form-control mb-3' placeholder='E-mail...' />
                <input ref={passRef} type='password' className='form-control' placeholder='Senha...' />

                {error && <Alert content={error} className={`alert-danger mb-0 ${shakeClass}`} />}
                <button type='submit' className='btn btn-primary mt-3'>Entrar</button>
                </form>
            </div>
        </div>
    </div>
}